var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3729 3.56611C16.2654 2.86052 15.0297 2.37998 13.7364 2.15195C10.4967 1.5807 7.33901 2.63841 5.15492 4.74975L5.68429 1.74757L3.71467 1.40027L2.49913 8.29393L9.39279 9.50946L9.74008 7.53985L5.92267 6.86673C7.63822 4.75003 10.4628 3.60557 13.3891 4.12156C14.4237 4.30399 15.4123 4.68842 16.2983 5.25289C17.1844 5.81737 17.9505 6.55083 18.5531 7.41141C19.1557 8.27199 19.5829 9.24283 19.8103 10.2685C20.0377 11.2942 20.0608 12.3546 19.8784 13.3892C19.6959 14.4238 19.3115 15.4124 18.747 16.2984C18.1826 17.1845 17.4491 17.9507 16.5885 18.5532C15.7279 19.1558 14.7571 19.583 13.7314 19.8104C12.7058 20.0378 11.6453 20.0609 10.6107 19.8785C8.52123 19.5101 6.66367 18.3267 5.4467 16.5886L3.80839 17.7358C5.32961 19.9083 7.65156 21.3876 10.2634 21.8481C11.5567 22.0761 12.8822 22.0472 14.1643 21.763C15.4464 21.4788 16.66 20.9448 17.7357 20.1915C18.8114 19.4383 19.7282 18.4806 20.4338 17.373C21.1394 16.2655 21.62 15.0298 21.848 13.7365C22.076 12.4432 22.0471 11.1177 21.7629 9.83563C21.4786 8.55354 20.9447 7.33998 20.1914 6.26426C19.4382 5.18853 18.4805 4.2717 17.3729 3.56611Z",
    fill: "#000032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.1e7758e00f75d6f9ab8f47d2c3780665.svg";
export { ForwardRef as ReactComponent };